import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./locales/it.json";
import italianCopy from "./copy/it.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";

import { storedPreference } from "./preference";

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it, copy: italianCopy },
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
  },
  lng: "it",
  fallbackLng: "it",
  supportedLngs: ["it", "en", "es", "fr", "de"],
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") document.documentElement.lang = "it";
export const storedLanguage = storedPreference();
export default i18n;
